import { combineReducers } from 'redux';

import { takeLatest } from 'redux-saga/effects';

import { environment } from 'environments/environment';
import {
  createActionType,
  createApiActionCreators,
  createReducer,
  RequestActionTypes,
} from 'helpers/redux/reduxHelpers';

/*STATE*/
export interface DownloadDoDocumentState {
  downloadLink: any;
}

/* ACTION TYPES */
export enum DownloadDoDocumentActionTypes {
  DownloadDoDocument = '@@DoDocument/DOWNLOAD_DO_DOCUMENT',
  SetDownloadLink = '@@DoDocument/SET_DOWNLOAD_LINK',
}

/* ACTIONS */
export const DownloadDoDocumentActions = createApiActionCreators(DownloadDoDocumentActionTypes.DownloadDoDocument);

/*REDUCERS*/
const initialState: DownloadDoDocumentState = {
  downloadLink: null,
};

const downloadLink = createReducer(initialState.downloadLink, {
  [DownloadDoDocumentActionTypes.SetDownloadLink]: {
    [RequestActionTypes.SUCCESS]: (state: DownloadDoDocumentState, payload: HTMLAnchorElement) => payload,
    [RequestActionTypes.FAILURE]: () => null,
  },
});

export default combineReducers<DownloadDoDocumentState>({
  downloadLink,
});

/* SAGAS */
function downloadDoDocument({ payload }: any) {
  const url = environment.properties[environment.urlConfig.eBillDownloader.propertyKey];
  const link = document.createElement('a');

  link.target = '_blank';
  link.href = `${url}/download/doDownload?HASHID=${payload.hashId}`;
  link.click();
  link.remove();
}

/* EXPORT */
export function* downloadDoDocumentSaga() {
  yield takeLatest(
    createActionType(DownloadDoDocumentActionTypes.DownloadDoDocument, RequestActionTypes.REQUEST),
    downloadDoDocument
  );
}
